const key = 'rfanled-draft-favorites-v1';
function readFavorites() {
  try {
    const data = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(data) ? data.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string') : [];
  } catch { return []; }
}
function writeFavorites(items) {
  localStorage.setItem(key, JSON.stringify(items));
  document.dispatchEvent(new CustomEvent('rfan:favorites-change'));
}
if (!customElements.get('rfan-product-favorite')) {
  customElements.define('rfan-product-favorite', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const items = readFavorites();
        const index = items.findIndex(item => item.handle === this.dataset.handle);
        if (index >= 0) items.splice(index, 1);
        else items.push({ handle: this.dataset.handle, title: this.dataset.title, url: this.dataset.url, image: this.dataset.image });
        try { writeFavorites(items); }
        catch { this.button.setAttribute('title', 'Browserul nu permite salvarea favoritelor.'); }
      }, options);
      const sync = () => {
        const active = readFavorites().some(item => item.handle === this.dataset.handle);
        this.button.setAttribute('aria-pressed', String(active));
        this.button.setAttribute('aria-label', active ? this.button.dataset.removeLabel : this.button.dataset.addLabel);
      };
      document.addEventListener('rfan:favorites-change', sync, options);
      window.addEventListener('storage', sync, options);
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('rfan-favorites-page')) {
  customElements.define('rfan-favorites-page', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const render = () => this.renderItems();
      document.addEventListener('rfan:favorites-change', render, options);
      window.addEventListener('storage', render, options);
      render();
    }
    disconnectedCallback() { this.controller?.abort(); }
    renderItems() {
      const items = readFavorites();
      this.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('p');
        empty.textContent = this.dataset.empty;
        this.append(empty);
        return;
      }
      const list = document.createElement('ul');
      list.className = 'rfan-favorites-grid';
      for (const item of items) {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '/products/' + encodeURIComponent(item.handle);
        if (item.image && (item.image.startsWith('//rfanled.com/') || item.image.startsWith('https://rfanled.com/'))) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          link.append(img);
        }
        const title = document.createElement('span');
        title.textContent = item.title;
        link.append(title);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = this.dataset.remove;
        remove.setAttribute('aria-label', this.dataset.remove + ': ' + item.title);
        remove.addEventListener('click', () => {
          try {
            writeFavorites(readFavorites().filter(saved => saved.handle !== item.handle));
            const next = this.querySelector('button');
            if (next) next.focus();
          } catch { /* Keep the visible saved state if storage is unavailable. */ }
        }, { signal: this.controller.signal });
        li.append(link, remove);
        list.append(li);
      }
      this.append(list);
    }
  });
}
